module.exports = __webpack_public_path__ + "img/features-cloud.3b9aedce.svg";